<template>
  <div class="tagMain" v-loading="loading">
    <div :class="[txtType !== 'word' ? 'tagBox1' : 'tagBox1']">
      <div
        :class="[
          tag.ResourcePlatformName === checkTag ? 'tagChecked' : 'tagBtn'
        ]"
        @click="check(tag)"
        v-for="tag in titlesTag"
        :key="tag.ResourcePlatformGuid"
      >
        {{ tag.ResourcePlatformName }}
      </div>
    </div>

    <div
      :class="[visible ? 'tagChecked' : 'tagBtn']"
      @click="moreTitle"
      class="more_box"
      v-if="false"
    >
      <span class="moreTag">...</span>
    </div>
    <div class="other_box" v-if="visible" @mouseleave="visible = false">
      <div
        :class="[
          tag.ResourcePlatformName === checkTag ? 'tagChecked' : 'tagBtn'
        ]"
        @click="check(tag)"
        v-for="tag in otherTag"
        :key="tag.ResourcePlatformGuid"
      >
        {{ tag.ResourcePlatformName }}
      </div>
    </div>
    <div
      class="optionsMain"
      v-for="item in activeTag"
      :key="item.RankingListGuid"
    >
      <div class="tagOptionList">
        <div
          class="optionsBtn"
          @click="tagCheck(tag.RankingListGuid, tag.RankingListName)"
          :class="[
            tag.RankingListGuid === tagCheckTag
              ? 'optionsChecked'
              : 'optionsBtn'
          ]"
          v-for="tag in optionCheck(tags_other, item.ResourcePlatformName)"
          :key="tag.RankingListGuid"
        >
          <i class="icons" :class="getIcons(item.ResourcePlatformName)"></i
          >{{ tag.RankingListName }}
        </div>
      </div>
      <el-popover
        width="450"
        trigger="click"
        popper-class="articlePopper"
        v-model="ArticleChecked"
        v-if="getOtherList.length > 5"
      >
        <div>
          <el-row>
            <el-col
              :span="tagnumber"
              v-for="tag in otherOptionCheck(item.ResourcePlatformName)"
              :key="tag.RankingListGuid"
              ><div
                @click="tagCheck(tag.RankingListGuid, tag.RankingListName)"
                class="tagBtn mrbottom"
                :class="[
                  tag.RankingListGuid === tagCheckTag ? 'tagChecked' : 'tagBtn'
                ]"
              >
                <i class="icons" :class="getIcons(tag.ResourcePlatformName)"></i
                >{{ tag.RankingListName }}
              </div></el-col
            >
          </el-row>
        </div>
        <div
          slot="reference"
          :class="[ArticleChecked ? 'tagChecked' : 'tagBtn']"
          class="more_box tagOptionMore"
        >
          <span class="moreTag">...</span>
        </div>
      </el-popover>
    </div>
    <div v-show="isSoaring">
      <SoaringWords></SoaringWords>
    </div>
    <div v-show="!isSoaring">
      <div class="top">
        <span
          >{{ ActiveRankName }}热搜榜 (更新于{{
            newUpdateTime | changeTime()
          }})</span
        >
        <span v-if="ActiveRankName === '每日精选'">
          作者
        </span>
        <span v-else-if="ActiveRankName === '电影榜'">日期</span>
        <span
          v-else-if="
            ActiveRankName !== '热词' &&
              ActiveRankName !== '历史上的今天' &&
              ActiveRankName !== '新时代' &&
              ActiveRankName !== '知道日报'
          "
          >热度</span
        >
      </div>
      <div class="bodyMain" id="ArticleMenuID">
        <HotArticleList
          :hot-data="HotNewData"
          :get-history-guid="getHistoryGuid"
          :txt-type="txtType"
        ></HotArticleList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HotArticleList from "../../components/hot/HotArticleList";
import SoaringWords from "../../components/share/SoaringWords";
export default {
  name: "ArticleMenu",
  props: ["txtType"],
  data() {
    return {
      visible: false,
      checkTag: "微信",
      tagCheckTag: "",
      ArticleChecked: false,
      tags_other: [],
      tags: [],
      HotNewData: [],
      getHistoryGuid: "",
      ActiveRankName: "",
      newUpdateTime: "",
      loading: false,
      tagnumber: 6,
      isSoaring: false
    };
  },
  created() {
    if (this.txtType !== "") this.getHotRankList();
  },
  mounted() {
    this.getHotLineHeight(this.contentHeight, "ArticleMenuID", 10);
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    titlesTag() {
      let i = 0;
      let num = 9;
      // this.txtType === "word" ? (num = 6) : (num = 7);
      return this.tags.filter(item => {
        i++;
        if (i <= num) {
          return item;
        }
      });
    },
    getOtherList() {
      return this.tags_other.filter(item => {
        if (item.ResourcePlatformName === this.checkTag) {
          return item;
        }
      });
    },
    otherTag() {
      let i = 0;
      let num = 9;
      // this.txtType === "word" ? (num = 6) : (num = 7);
      return this.tags.filter(item => {
        i++;
        if (i > num) {
          return item;
        }
      });
    },
    activeTag() {
      return this.tags.filter(item => {
        if (item.ResourcePlatformName === this.checkTag) {
          return item;
        }
      });
    }
  },
  components: {
    HotArticleList,
    SoaringWords
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "ArticleMenuID", 10);
      }
    },
    tagCheckTag: {
      handler(val) {
        if (val !== "") {
          this.getHotNewList(val);
        }
      }
    },
    txtType: {
      handler(val) {
        if (val !== "") {
          this.visible = false;
          this.checkTag = "微信";
          this.tagCheckTag = "";
          this.ArticleChecked = false;
          this.tags_other = [];
          this.tags = [];
          this.HotNewData = [];
          this.getHistoryGuid = "";
          this.ActiveRankName = "";
          this.newUpdateTime = "";
          this.loading = false;
          this.tagnumber = 6;
          this.isSoaring = false;
          this.getHotRankList();
        }
      }
    }
  },
  methods: {
    ...mapActions("hotList", [
      "AHotRankList",
      "AHotRankNewList",
      "AHotRankHistoryList"
    ]),
    check(type) {
      // if (type < 9) this.visible = false;
      this.isSoaring = false;
      this.scrollTop("bodyMain", "class");
      this.checkTag = type.ResourcePlatformName;
      let i = 1;
      this.tags_other.map(item => {
        if (item.ResourcePlatformName === this.checkTag) {
          if (i === 1) {
            i++;
            this.tagCheckTag = item.RankingListGuid;
            this.ActiveRankName = item.RankingListName;
          }
        }
      });
    },
    tagCheck(type, name) {
      if (name === "流量暴涨") {
        this.isSoaring = true;
        this.tagCheckTag = type;
        this.ArticleChecked = false;
      } else {
        this.isSoaring = false;
        this.scrollTop("bodyMain", "class");
        this.tagCheckTag = type;
        this.ArticleChecked = false;
        this.ActiveRankName = name;
      }
    },
    moreTitle() {
      this.visible = !this.visible;
      // if (this.checkTag < 9) this.checkTag = 0;
    },
    ArticlemoreTitle() {
      this.ArticleChecked = !this.ArticleChecked;
      // if (this.checkTag < 9) this.checkTag = 0;
    },
    getIcons(name) {
      if (name === "微信") {
        return "wechat";
      }
      if (name === "头条") {
        return "toutiao";
      }
      if (name === "知乎") {
        return "zhihu";
      }
      if (name === "360") {
        return "haosou";
      }
      if (name === "神马") {
        return "shenma";
      }
      if (name === "百度") {
        return "baidu";
      }
      if (name === "简书") {
        return "jianshu";
      }
      if (name === "历史今天") {
        return "htody";
      }
      if (name === "搜狗") {
        return "sogou";
      }
      if (name === "网易") {
        return "wangyi";
      }
      if (name === "新浪") {
        return "sina";
      }
      if (name === "微博") {
        return "weibo";
      }
      if (name === "360") {
        return "haosou";
      }
    },
    sortId(a, b) {
      return a.istitle - b.istitle;
    },
    optionCheck(list, name) {
      if (list !== null > 0 && list) {
        let i = 0;
        let num = 4;
        if (name === "百度") {
          this.tagnumber = 8;
        } else if (name === "微信") {
          this.tagnumber = 4;
        } else if (name === "网易") {
          this.tagnumber = 8;
        } else {
          this.tagnumber = 6;
        }
        if (name === "微信") num = 6;
        if (name === "知乎") num = 5;
        if (name === "百度") num = 4;
        // this.txtType === "word" ? (num = 4) : (num = 3);
        return list.filter(item => {
          if (item.ResourcePlatformName === this.checkTag) {
            i++;
            if (i <= num) {
              return item;
            }
          }
        });
      }
    },
    async getHotRankList() {
      this.loading = true;
      let data = { TxtType: this.txtType };
      let result = await this.AHotRankList(data);
      if (result.ErrorCode === 0) {
        this.loading = false;
        this.tags = result.Data.Platform;
        this.tags_other = result.Data.Ranking;
        // this.tags_other.push({
        //   NewCount: 55,
        //   RankingListGuid: "7873d888-54d8-ea11-b0d1-d4ae52d0f72c",
        //   RankingListName: "流量暴涨",
        //   ResourcePlatformGuid: "75e1b888-a430-e811-b201-d4ae52d0f72c",
        //   ResourcePlatformName: "百度",
        //   TxtType: "word"
        // });
        i = 1;
        this.tags.map(item => {
          if (i === 1) {
            i++;
            this.checkTag = item.ResourcePlatformName;
          }
        });
        let i = 1;
        this.tags_other.map(item => {
          if (item.ResourcePlatformName === this.checkTag) {
            if (i === 1) {
              i++;
              this.tagCheckTag = item.RankingListGuid;
              this.ActiveRankName = item.RankingListName;
            }
          }
        });
      }
    },
    async getHotNewList(guid) {
      this.getHistoryGuid = guid;
      let data = { rankingListGuid: guid };
      let result = await this.AHotRankNewList(data);
      if (result.ErrorCode === 0) {
        this.HotNewData = result.Data.New;
        this.newUpdateTime = result.Data.UpdateTime;
      }
    },
    otherOptionCheck(name) {
      let i = 0;
      let num = 4;
      if (name === "百度") {
        this.tagnumber = 8;
      } else if (name === "微信") {
        this.tagnumber = 4;
      } else if (name === "网易") {
        this.tagnumber = 8;
      } else {
        this.tagnumber = 6;
      }
      if (name === "微信") num = 6;
      if (name === "知乎") num = 5;
      if (name === "百度") num = 4;
      // this.txtType === "word" ? (num = 4) : (num = 3);
      return this.tags_other.filter(item => {
        if (item.ResourcePlatformName === name) {
          i++;
          if (i > num) {
            return item;
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.tagMain {
  padding: 0 2px 0 5px;
}
.tagBox {
  display: inline-block;
  width: 408px;
}
.tagBox1 {
  width: 470px !important;
}
.top {
  margin-top: 10px;
  display: flex;
  color: #666;
  justify-content: space-between;
  padding: 0 48px 0 10px;
}
.more_box {
  position: absolute;
  width: 40px;
  display: inline-block;
  .moreTag {
    position: absolute;
    margin-top: -7px;
    font-size: 24px;
    margin-left: -2px;
  }
}
.mrbottom {
  margin-bottom: 10px;
}
.optionsMain {
  height: 50px;
  border-bottom: 1px solid #d3d7de;
  padding: 10px 0;
}
.optionsBtn {
  margin-left: 5px;
  height: 24px;
  line-height: 3px;
  border-radius: 15px;
  background-color: #fff;
  border: 1px solid #dde3f2;
  padding: 10px 7px;
  color: #666;
  display: inline-block;
  cursor: pointer;
}
.optionsChecked {
  .optionsBtn;
  color: #1058f6;
  border: 1px solid #1058f6;
}
.tagBtn {
  margin-left: 5px;
  height: 24px;
  line-height: 3px;
  border-radius: 15px;
  background-color: #f5f8ff;
  border: 1px solid #dde3f2;
  padding: 10px;
  color: #666;
  display: inline-block;
  cursor: pointer;
}
.other_box {
  display: block;
  margin-top: 10px;
  border: 1px solid #dde3f2;
  padding: 10px;
  border-radius: 10px;
  position: absolute;
  text-align: right;
  width: 465px;
  z-index: 10;
  background-color: #fff;
}
.tagChecked {
  .tagBtn;
  background-color: #1058f6;
  color: #fff;
  border: 1px solid #1058f6;
}
.tagOptionMore {
  float: right;
  display: inline-block;
  height: 20px;
  line-height: 0px;
  width: 35px;
  margin-top: 1px;
}
.tagOptionList {
  width: 420px;
  display: inline-block;
}
.bodyMain {
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
}
.icons {
  display: inline-block;
  height: 12px;
  width: 12px;
  vertical-align: top;
  margin-top: -5px;
  margin-right: 2px;
}
.wechat {
  .bgicons("wechat");
}
.zhihu {
  .bgicons("zhihu");
}
.wangyi {
  .bgicons("wangyi");
}
.toutiao {
  .bgicons("toutiao");
}
.baidu {
  .bgicons("baidu");
}
.htody {
  .bgicons("htody");
}
.sina {
  .bgicons("sina");
}
.weibo {
  .bgicons("weibo");
}
.jianshu {
  .bgicons("jianshu");
}
.sogou {
  .bgicons("sogou");
}
.shenma {
  .bgicons("shenma");
}
.haosou {
  .bgicons("haosou");
}
</style>
<style lang="less">
.articlePopper {
  font-size: 12px;
  margin-top: 8px !important;
  border: 1px solid #dde3f2;
  left: 80px !important;
  padding: 12px 5px 2px 5px !important;
  .popper__arrow {
    margin-left: 410px !important;
  }
}
</style>
